// ラベル
$(() => {
    if (document.getElementById('label-form') != null) {
        // アクター取得
        const actor = location.pathname.split("/")[1];
        // エンターで誤登録を制御
        $("input").keypress(function (e) {
            if (e.which === 13) {
                return false;
            }
        });
        // ajax設定
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        // 登録処理
        $('#submit').on('click', function(){
            let inputs = $('#add_label').serialize();
            $('input[name="label_name"]').prop('disabled', true);
            $('#submit').prop('disabled', true);
            $.ajax({
                type: 'POST',
                url: '/' + actor + '/labels/ajax',
                data: inputs,
                dataType : 'json'
            }).done(function(data){
                $('input[name="label_name"]').prop('disabled', false);
                $('#submit').prop('disabled', false);
                if (data.success) {
                    $('input[name="label_name"]').val('');
                    $('#label_modal').find('#errors').html('');
                    if ($('select#labels').length) {
                        let opt = new Option(data.label_name, data.id, false, false);
                        $('select#labels').append(opt);
                        let val = $('select#labels').val();
                        val.push(data.id);
                        $('select#labels').val(val).trigger('change');
                    } else {
                        $('#labels').append('<a href="/' + actor + '/labels/' + data.id + '/edit" class="list-group-item list-group-item-action" role="row">' + data.label_name + '</a>');
                    }

                    $('#label_modal').modal('hide');
                } else {
                    if (data.error) {
                        $('#label_modal').find('#errors').html('<div class="alert alert-danger" role="alert">' + data.error + '</div>');
                    } else {
                        $('#label_modal').modal('hide');
                    }
                }
            }).fail(function(XMLHttpRequest, textStatus, error){
                alert('登録できませんでした。');
            });
        });
    }
});
